import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-762fe970"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "target-drawer-body" }

import { computed, nextTick, reactive, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import CmTable from '@/components/cmTable/index.vue'
import type { SoftwareDisabledProcessInfo } from '@/views/dashboard/policy/software-disabled/software-disabled.service'
import type { TableOpt } from '@/components/cmTable/types'
import {
  SoftwareListService,
  SoftwareInfo,
} from '@/views/dashboard/policy/software-disabled/_components/software-list/software-list.service'
import { http } from '@/common/basis/root-injector'
import { formatTimeStamp } from '@/utils/time'
import { formatTableEmpty } from '@/utils/format'

const TAB_SOFTWARE = 'software'
const TAB_PROCESS = 'process'


export default /*#__PURE__*/_defineComponent({
  __name: 'process-infos-list-drawer',
  props: {
    modelValue: { type: Boolean },
    policyName: {},
    policyId: {},
    processInfos: {},
    defaultTab: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const { t, locale } = useI18n()
const softwareListService = new SoftwareListService(http)

const drawerTitle = computed(() => {
  void locale.value
  const name = (props.policyName ?? '').trim() || '--'
  return t('softwareDisabledLog.targetObjectsDrawerTitleWithBracket', { name })
})

const activeTab = ref<typeof TAB_SOFTWARE | typeof TAB_PROCESS>(TAB_SOFTWARE)

const softwareTableRef = ref<{ getList?: (...args: unknown[]) => void } | null>(null)
const processTableRef = ref<{ getList?: (...args: unknown[]) => void } | null>(null)

const snapshot = ref<Array<SoftwareDisabledProcessInfo & { _rowKey: string }>>([])

const softwareQueryParams = reactive({
  page: 1,
  limit: 999,
})

const processQueryParams = reactive({
  page: 1,
  limit: 999,
})

function handleClose () {
  emit('update:modelValue', false)
}

function onTabClick () {
  void nextTick(() => {
    void nextTick(() => {
      if (activeTab.value === TAB_SOFTWARE) {
        softwareTableRef.value?.getList?.()
      } else {
        processTableRef.value?.getList?.()
      }
    })
  })
}
const softListTotal = ref(0)
async function softwareListApi (params: Record<string, unknown>) {
  if (!props.policyId) {
    return { list: [] as SoftwareInfo[], total: 0 }
  }
  const page = Number(params.page ?? softwareQueryParams.page) || 1
  const limit = Number(params.limit ?? softwareQueryParams.limit) || 10
  const res = await softwareListService.getSoftwareList({
    strategy_id: props.policyId,
    page,
    limit,
  })
  const list = (res.list || []).map((r, i) => ({
    ...r,
    _sk: `${r.soft_id ?? 'x'}_${i}_${page}_${limit}`,
  }))
  softListTotal.value = res.total
  return {
    list,
    total: Number(res.total) || 0,
  }
}

function processRowHasAnyField (row: SoftwareDisabledProcessInfo) {
  return [row.name, row.path, row.md5, row.signature].some((f) => String(f ?? '').trim() !== '')
}
const processTotal = ref(0)
async function localProcessListApi (params: Record<string, unknown>) {
  const page = Number(params.page ?? processQueryParams.page) || 1
  const limit = Number(params.limit ?? processQueryParams.limit) || 999
  const all = snapshot.value.filter(processRowHasAnyField)
  const start = (page - 1) * limit
  const list = all.slice(start, start + limit)
  processTotal.value = all.length
  return {
    list,
    total: all.length,
  }
}

const softwareTableOpt = computed<TableOpt>(() => {
  void locale.value
  return {
    bodyStyle: 'background: transparent; padding: 0',
    containerOpt: { style: 'padding: 0; min-height: 240px' },
    height: '100%',
    path: 'list',
    totalPath: 'total',
    showActionBar: false,
    showForm: false,
    showRightToolbar: false,
    showSearch: false,
    rowKey: '_sk',
    selection: false,
    showTip: false,
    usePagination: false,
    disableScrollLoad:false,
    columns: [
      { label: t('softwareDisabledLog.targetSoftwareColSoftName'), prop: 'soft_name', minWidth: 120, showOverflow: true },
      {
        label: t('softwareDisabledLog.targetSoftwareColCategory'),
        prop: 'soft_group_name',
        minWidth: 100,
        formatter: (row: SoftwareInfo, _v: unknown, column: unknown) => formatTableEmpty(row, column, row.soft_group_name),
      },
      {
        label: t('softwareDisabledLog.targetSoftwareColPublish'),
        prop: 'publish_time',
        minWidth: 150,
        formatter: (_row: SoftwareInfo, val: number) => formatTimeStamp(val) || '--',
      },
      {
        label: t('softwareDisabledLog.targetSoftwareColVersion'),
        prop: 'soft_version',
        minWidth: 130,
        formatter: (row: SoftwareInfo, _v: unknown, column: unknown) => formatTableEmpty(row, column, row.soft_version),
      },
    ],
  }
})

const processTableOpt = computed<TableOpt>(() => {
  void locale.value
  return {
    bodyStyle: 'background: transparent; padding: 0',
    containerOpt: { style: 'padding: 0; min-height: 240px' },
    height: '100%',
    path: 'list',
    totalPath: 'total',
    showActionBar: false,
    showForm: false,
    showRightToolbar: false,
    showSearch: false,
    rowKey: '_rowKey',
    selection: false,
    showTip: false,
    usePagination: false,
    disableScrollLoad:false,
    columns: [
      { label: t('softwareDisabledEdit.processName'), prop: 'name', minWidth: 140, showOverflow: true },
      { label: t('softwareDisabledEdit.pathLabel'), prop: 'path', minWidth: 200, type: 'PATH' },
      { label: t('softwareDisabledEdit.md5Label'), prop: 'md5', minWidth: 260, type: 'MD5', fieldKey: 'md5' },
      { label: t('softwareDisabledEdit.signatureLabel'), prop: 'signature', minWidth: 160, showOverflow: true },
    ],
  }
})

watch(
  () => props.modelValue,
  (open) => {
    if (!open) return
    activeTab.value = props.defaultTab === TAB_PROCESS ? TAB_PROCESS : TAB_SOFTWARE
    const rows = props.processInfos ?? []
    snapshot.value = rows.map((row, index) => ({
      ...row,
      _rowKey: `${index}-${row.md5 || ''}-${row.path || ''}-${row.name || ''}`,
    }))
    softwareQueryParams.page = 1
    processQueryParams.page = 1
    void nextTick(() => {
      void nextTick(() => {
        if (activeTab.value === TAB_SOFTWARE) {
          softwareTableRef.value?.getList?.()
        } else {
          processTableRef.value?.getList?.()
        }
      })
    })
  },
)

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    "append-to-body": "",
    title: drawerTitle.value,
    "model-value": _ctx.modelValue,
    "show-close": "",
    size: "56%",
    "destroy-on-close": "",
    onClose: handleClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_tabs, {
          modelValue: activeTab.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((activeTab).value = $event)),
          onTabClick: onTabClick
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, {
              lazy: "",
              label: _ctx.$t('softwareDisabledLog.tabTargetSoftware')+'('+softListTotal.value+')',
              name: TAB_SOFTWARE
            }, {
              default: _withCtx(() => [
                _createVNode(CmTable, {
                  ref_key: "softwareTableRef",
                  ref: softwareTableRef,
                  modelValue: softwareQueryParams,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((softwareQueryParams) = $event)),
                  api: softwareListApi,
                  "table-opt": softwareTableOpt.value,
                  "first-loading": true,
                  "page-option": {
              style: 'padding: 12px 0',
              pageNumName: 'page',
              pageSizeName: 'limit',
            }
                }, null, 8, ["modelValue", "table-opt"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_tab_pane, {
              label: _ctx.$t('softwareDisabledLog.tabTargetProcess')+'('+processTotal.value+')',
              name: TAB_PROCESS
            }, {
              default: _withCtx(() => [
                _createVNode(CmTable, {
                  ref_key: "processTableRef",
                  ref: processTableRef,
                  modelValue: processQueryParams,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((processQueryParams) = $event)),
                  api: localProcessListApi,
                  "table-opt": processTableOpt.value,
                  "first-loading": true,
                  "page-option": {
              style: 'padding: 12px 0',
              pageNumName: 'page',
              pageSizeName: 'limit',
            }
                }, null, 8, ["modelValue", "table-opt"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _: 1
  }, 8, ["title", "model-value"]))
}
}

})